import { cn } from '#/utils/cn';

export function PageTitle({
  children,
  as: Component = 'h1',
  flush = false,
}: {
  children: React.ReactNode;
  as?: React.ElementType;
  flush?: boolean;
}) {
  return (
    <Component
      className={cn(
        'text-fluid-header text-fg-header leading-tight font-semibold text-pretty',
        flush ? 'flow-0' : '',
      )}
    >
      {children}
    </Component>
  );
}
